import { useTheme } from 'foundations-theming/utils';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FeedbackRatingButton({
  selected,
  icon,
  filledIcon,
  color,
  onClick,
  tooltip
}) {
  const trellisTheme = useTheme();
  return /*#__PURE__*/_jsx(UIIconButton, {
    use: "unstyled",
    onClick: onClick,
    tooltip: tooltip,
    placement: "bottom",
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: selected ? filledIcon : icon,
      size: 32,
      color: selected ? color : trellisTheme.color['do-not-use-eerie']
    })
  });
}